import { RegisterOptions, useFormContext } from "react-hook-form";

export interface IFormTextareaProps
    extends React.DetailedHTMLProps<
        React.TextareaHTMLAttributes<HTMLTextAreaElement>,
        HTMLTextAreaElement
    > {
    // propriedade herdadas obrigatórias
    name: string;
    ref?: undefined;

    // outras propriedades
    wrapperClassName?: string;
    labelClassName?: string;
    registerOptions?: RegisterOptions;
    label?: string;

    noRezise?: boolean;
}

export default function FormTextarea(props: IFormTextareaProps) {
    const { register, formState } = useFormContext();

    const {
        wrapperClassName,
        registerOptions,
        label,
        labelClassName,
        noRezise,
        ...textareaProps
    } = props;

    return (
        <span className={wrapperClassName}>
            {label && <label className={labelClassName}>{label}</label>}
            <textarea
                {...textareaProps}
                className={`form-control placeholder-dark-50 ${
                    textareaProps.className
                } ${formState.errors[textareaProps.name] && "is-invalid"}`}
                ref={register(registerOptions)}
                style={{
                    resize: noRezise ? "none" : props.style?.resize,
                    ...props.style,
                }}
            />
            <div className="invalid-feedback">
                {formState.errors[textareaProps.name]?.message ?? ""}
            </div>
        </span>
    );
}
